<template>
  <div id="app" style="left: 0;top:0;position: absolute">
    <!--      <router-link to="/login">登录页</router-link>-->
    <!--      <router-link to="/index">首页</router-link>-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      tableData: []
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
}
</style>
